import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const user = useSelector((state) => state.users);

  return user[0] ? <Outlet /> : <Navigate to="/sign-in" />;
};

export default PrivateRoute;
